<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-padding-bottom-16">
    <span class="cf-icon cf-icon--brand-primary cf-icon--large far fa-clock" />

    <p
      v-if="isTimeslotVerificationRequired"
      class="cf-subtitle cf-subtitle--1"
    >
      {{ verificationTimeslotContent.description }}
    </p>

    <p
      v-else
      class="cf-subtitle cf-subtitle--1"
    >
      {{ defaultVerificationContent }}
    </p>

    <h3 class="cf-title cf-title--2">
      {{ fulfillmentTimeContent }}
    </h3>

    <p class="cf-subtitle cf-subtitle--1">
      {{ verificationTimeslotContent.subDescription }}
    </p>

    <button
      type="button"
      class="cf-button cf-button--primary cf-button--lg cf-button--fill"
      @click="confirmButtonHandler(true)"
    >
      {{ verificationTimeslotContent.primaryCta }}
    </button>

    <button
      type="button"
      class="cf-button cf-button--secondary cf-button--lg cf-button--fill"
      @click="confirmButtonHandler(false)"
    >
      {{ verificationTimeslotContent.secondaryCta }}
    </button>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import momentCalendar from '@/filters/moment-calendar';


  export default {
    name: 'ConfirmFulfillmentTime',

    props: {
      isTimeslotVerificationRequired: {
        type: Boolean,
        default: false
      },

      previousSelectedTime: {
        type: String,
        required: true
      },

      confirmClickHandler: {
        type: Function,
        required: true
      }
    },

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('locations', ['selectedLocation']),
      ...mapGetters('session', ['orderDetails']),

      deliveryContent() {
        const { description, metadata } = this.content.DeliveryModal;

        const stringResult = this.matchRegex(description);

        const content = {
          description: stringResult,
          subDescription: metadata.subDescription,
          primaryCta: metadata.primaryCta,
          secondaryCta: metadata.secondaryCta
        };

        return content;
      },

      pickupContent() {
        const { description, metadata } = this.content.PickupModal;

        const stringResult = this.matchRegex(description);

        const content = {
          description: stringResult,
          subDescription: metadata.subDescription,
          primaryCta: metadata.primaryCta,
          secondaryCta: metadata.secondaryCta
        };

        return content;
      },

      verificationTimeslotContent() {
        if (this.orderDetails.fulfillmentType === 'delivery') {
          return this.deliveryContent;
        }

        return this.pickupContent;
      },

      defaultVerificationContent() {
        if (this.orderDetails.fulfillmentType === 'delivery') {
          return 'Your delivery time is:';
        }

        return 'Your pickup time is:';
      },

      fulfillmentTimeContent() {
        const content = momentCalendar(this.orderDetails.fulfillmentTime, null, this.selectedLocation.timeZone);

        return content;
      }
    },

    methods: {
      confirmButtonHandler(confirmStatus) {
        this.$closeModal('confirmTime');

        this.confirmClickHandler(confirmStatus);
      },

      matchRegex(inputString) {
        const momentSelectedTime = momentCalendar(this.previousSelectedTime, null, this.selectedLocation.timeZone);

        const regex = /%@/i;

        return inputString.replace(regex, momentSelectedTime);
      }
    }
  };
</script>
